import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '../../../../../environments/environment';
import { PaginableResponseModel } from '../../../common/models/paginable-response.model';
import { SingleResponseModel } from '../../../common/models/single-response.model';
import { SummaryRecurrentListModel, SummaryRecurrentModel } from '../models/summary-recurrent.model';

@Injectable({ providedIn: 'root' })
export class RecurrentService {
  private fullUrl = `${environment.apiUrl}/api/v2/recurrents`;
  private preinvoicesUrl = `${environment.apiUrl}/api/v2/preinvoices`;

  constructor(private http: HttpClient) { }

  getSummaryList(
    filter: any
  ): Observable<PaginableResponseModel<SummaryRecurrentModel> & { summary: SummaryRecurrentListModel }> {
    return this.http.post<PaginableResponseModel<SummaryRecurrentModel> & { summary: SummaryRecurrentListModel }>(
      `${this.fullUrl}/list`,
      filter
    );
  }

  getDetailByUid(uid: string): Observable<SingleResponseModel<any>> {
    return this.http.get<SingleResponseModel<any>>(`${this.preinvoicesUrl}/${uid}`);
  }
}
